import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.9 24.35"><title>SiteIcons</title><path d="M28.07,4.29H12.9V.83A.83.83,0,0,0,12.07,0H.83A.83.83,0,0,0,0,.83V23.52a.83.83,0,0,0,.83.83H28.07a.83.83,0,0,0,.83-.83V5.12A.83.83,0,0,0,28.07,4.29ZM1.66,1.66h9.59V4.29H1.66Zm25.58,21H1.66V5.95H27.24Z"/></svg>
)